import { PaymentMethodType } from "./StripeForm"

import { isValidEmail } from "@/utils/strings/email"

const emailRequiredPaymentMethods: PaymentMethodType[] = [
	"bank_transfer",
	"konbini",
]

const nameRequiredPaymentMethods: PaymentMethodType[] = ["konbini"]

export const isEmailRequired = (paymentMethodType: PaymentMethodType) => {
	return emailRequiredPaymentMethods.includes(paymentMethodType)
}

export const isNameRequired = (paymentMethodType: PaymentMethodType) => {
	return nameRequiredPaymentMethods.includes(paymentMethodType)
}

export const isValidEmailForPayment = (
	paymentMethod: PaymentMethodType,
	email: string
): boolean => {
	if (isEmailRequired(paymentMethod)) {
		return isValidEmail(email)
	}

	if (email === "") {
		return true
	}
	return isValidEmail(email)
}

export const isValidNameForPayment = (
	paymentMethod: PaymentMethodType,
	name: string
): boolean => {
	if (isNameRequired(paymentMethod)) {
		return name.trim().length > 0
	}
	return true
}
